import request from '../utils/request';
import Config from '../config';
export var getUserId = function () {
    return request.get(Config.APE_HOST + "/accounts/api/current")
        .then(function (res) {
        return JSON.parse(res.body);
    })
        .catch(function () {
        return {
            id: 0
        };
    });
};
